import * as Yup from "yup";

export const resetpasswordSchema = Yup.object().shape({
  password: Yup.string().min(8,"Password can not be less than 8 characters!").max(16,"Password can not be more than 16 characters!").required("Enter new password!"),
  confirmpassword: Yup.string().required("Enter confirm password!").oneOf([Yup.ref('password'), null], 'Passwords must match!'),
});
